import { useFeature } from "flagged";
import * as React from "react";
import { useTranslation } from "react-i18next";

import EntitlementTable from "./EntitlementTable";
import ApplicationLayout from "components/layout/ApplicationLayout";
import AddEntitlementView from "components/licenses/entitlements/add-entitlement/AddEntitlementView";
import { LICENSES_ROUTE } from "components/router/Routes";
import { AUTH_EMS_CREATE_ENTITLEMENT } from "domain/authority";
import { Container, EmsConfiguration, LicenseData } from "domain/licenses";
import { FLAG_MANUAL_ENTITLEMENT_LIMITATION } from "services/feature/FeatureFlagService";
import { ProductRateList } from "services/licenses/LicenseService";
import { hasTenantCookie } from "services/tenants/tenantCookieService";
import { userSessionService } from "services/user/UserSessionService";

export default function EntitlementView(): JSX.Element {
    const { t } = useTranslation();
    const [state, setState] = React.useState({ count: 0 });
    const [emsConfiguration, setEmsConfiguration] = React.useState<EmsConfiguration>({
        emsId: "",
        hlEntitlements: false,
        slEntitlements: false,
        availableSlActivations: 0,
        usedSlActivations: 0,
        lastSynced: "",
    });

    const [availableLicenses, setAvailableLicenses] = React.useState<LicenseData[]>([]);
    const [tokenRateList, setTokenRateList] = React.useState<ProductRateList[]>([]);
    const manualEntitlementLimitation = useFeature(FLAG_MANUAL_ENTITLEMENT_LIMITATION);

    const [containers, setContainers] = React.useState<Container[]>([]);
    function updateState() {
        return setState((prevState) => ({ count: prevState.count + 1 }));
    }
    const allowManualSlEntitlementCreation = !manualEntitlementLimitation && emsConfiguration.slEntitlements;

    return (
        <ApplicationLayout
            viewTitle={t("Entitlements.title")}
            view={
                <EntitlementTable
                    initialEntitlement={{
                        entitlements: [],
                        cursor: null,
                        count: 0,
                    }}
                    requestFailureMessage={""}
                    count={state.count}
                    onUpdate={updateState}
                    onFetchEmsConfiguration={setEmsConfiguration}
                    onFetchAvailableLicenses={setAvailableLicenses}
                    onFetchContainers={setContainers}
                    containers={containers}
                    onFetchingRates={setTokenRateList}
                />
            }
            mainRoute={LICENSES_ROUTE}
            viewActions={
                !hasTenantCookie() &&
                userSessionService.userHasAllAuthorities([AUTH_EMS_CREATE_ENTITLEMENT]) &&
                (emsConfiguration.hlEntitlements || allowManualSlEntitlementCreation) &&
                availableLicenses.length > 0 ? (
                    <AddEntitlementView
                        emsConfiguration={emsConfiguration}
                        availableLicenses={availableLicenses}
                        slContainers={containers}
                        onUpdate={updateState}
                        tokenRates={tokenRateList}
                    />
                ) : (
                    <></>
                )
            }
        />
    );
}
